export default {

  methods: {

    set_LocalValues(){
      
      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      this.dataset = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.radar = json.radar
      this.series = json.series
      this.sundries = json.sundries
      this.title = json.title
      this.grids = json.grids
      this.axes = json.axes
      this.sundries  = json.sundries
      this.value = json.value
      this.legends = json.legends


      this.series.item.forEach((d,i)=> {
        d.value = this.rawData[d.code]
      })
     
    },
    
  }
}